import { configureStore } from '@reduxjs/toolkit';
import app from './app-dux/app-dux';
import people from '../app/components/recognize/people/reducer';
import programs from '../app/components/recognize/program/reducer';
import award from '../app/components/recognize/awards/reducer';
import message from '../app/components/recognize/message/reducer';


/*******************************************************************************
 *  Gather all the reducers
 */
const rootReducer = {
    app,
    people,
    programs,
    award,
    message
};

const AppStore = configureStore( {
    reducer: rootReducer,
} );

export default AppStore;
